import { useRef, useEffect, useCallback } from 'react';
import { AnimationConfig } from '../../types';

export function useAnimation() {
  const animationRef = useRef<number>();
  const startTimeRef = useRef<number>();

  const animate = useCallback(
    (
      onUpdate: (progress: number) => void,
      { duration, easing = t => t, onComplete }: AnimationConfig
    ) => {
      const tick = (currentTime: number) => {
        if (!startTimeRef.current) {
          startTimeRef.current = currentTime;
        }

        const elapsed = currentTime - startTimeRef.current;
        const progress = Math.min(elapsed / duration, 1);
        const easedProgress = easing(progress);

        onUpdate(easedProgress);

        if (progress < 1) {
          animationRef.current = requestAnimationFrame(tick);
        } else {
          onComplete?.();
        }
      };

      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }

      startTimeRef.current = undefined;
      animationRef.current = requestAnimationFrame(tick);
    },
    []
  );

  useEffect(() => {
    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, []);

  return animate;
}
